/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloTipoIdentificacion from 'Infotrack@Modelos/administracion/tipoIdentificacion';
import ITipoIdentificacion from 'Infotrack@Modelos/administracion/tipoIdentificacion/entidades/tipoIdentificacion';

export default class ControladorModeloTipoIdentificacion {
    private modeloTipoIdentificacion: ModeloTipoIdentificacion;
    constructor() {
        this.modeloTipoIdentificacion = new ModeloTipoIdentificacion();
    }

    public consultarTipoIdentificacion() {
        return this.modeloTipoIdentificacion.consultarTipoIdentificacion().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearTipoIdentificacion(tipoIdentificacion: ITipoIdentificacion) {
        await this.modeloTipoIdentificacion.crearTipoIdentificacion(tipoIdentificacion);
    }

    public async editarTipoIdentificacion(tipoIdentificacion: ITipoIdentificacion) {
        await this.modeloTipoIdentificacion.editarTipoIdentificacion(tipoIdentificacion);
    }

    public async eliminarTipoIdentificacion(tipoIdentificacion: ITipoIdentificacion) {
        await this.modeloTipoIdentificacion.eliminarTipoIdentificacion(tipoIdentificacion);
    }

    public validarEntidad(tipoIdentificacion: ITipoIdentificacion): boolean {
        if (tipoIdentificacion.Abreviatura === '' || tipoIdentificacion.DescripcionTipoIdentificacion === '') {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
